import Immutable from "immutable";

import ClubBooking from "state/school_money/entities/ClubBooking";
import OtherPayment from "state/school_money/entities/OtherPayment";

export const ParentalConsentItem = new Immutable.Record({
  id: undefined,
  serverID: undefined,
  remoteSchoolID: undefined,
  schoolID: undefined,
  studentID: undefined,
  remoteParentID: undefined,
  remoteInstallmentID: undefined,
  type: undefined,
  description: undefined,
  dueDate: undefined,
  isGiven: undefined
});

function buildParentalConsentItemFromActivePayment(activePayment) {
  if (activePayment instanceof ClubBooking) {
      return buildParentalConsentItemFromClubBooking(activePayment);
  } else if (activePayment instanceof OtherPayment) {
      return buildParentalConsentItemFromOtherPayment(activePayment);
  }
}

function buildParentalConsentItemFromClubBooking(clubBooking) {
  return ParentalConsentItem({
    ...getHeaders(clubBooking),
    type: "clubBooking",
    description: clubBooking.description,
    dueDate: clubBooking.startDate,
    isGiven: clubBooking.isParentalConsentGiven
  });
}

function buildParentalConsentItemFromOtherPayment(otherPayment) {
  return ParentalConsentItem({
    ...getHeaders(otherPayment),
    type: "otherPayment",
    description: otherPayment.description,
    dueDate: otherPayment.installments.first().dueDate,
    isGiven: otherPayment.isParentalConsentGiven
  });
}

function getHeaders(activePayment) {
  return {
    id: activePayment.id,
    serverID: activePayment.serverID,
    remoteSchoolID: activePayment.remoteSchoolID,
    schoolID: activePayment.schoolID,
    studentID: activePayment.studentID,
    remoteParentID: activePayment.appserverReferenceEntityID,
    remoteInstallmentID: activePayment.remoteInstallmentID
  }
}

ParentalConsentItem.fromActivePayment = buildParentalConsentItemFromActivePayment;
export default ParentalConsentItem;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/ParentalConsentItem.js